import { Component, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { slideInFromBottomAnimation } from '../scss/slide-in-from-bottom-animation';
import { BcAnalytics } from 'common/analytics/analytics.service';

@Component({
  selector: 'text-chat-more-actions',
  templateUrl: './text-chat-more-actions.component.html',
  animations: [slideInFromBottomAnimation],
  encapsulation: ViewEncapsulation.None
})

export class TextChatMoreActionsComponent {
  @Input() hasWrapUps: boolean;

  @Output() transfer: EventEmitter<any> = new EventEmitter<any>();

  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();

  @Output() end: EventEmitter<any> = new EventEmitter<any>();

  @Output() wrapup: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bcAnalytics: BcAnalytics) {
  }

  wrapUpButtonClick() {
    this.wrapup.emit();
    this.bcAnalytics.eventTrack('WrapUpTextChat');
  }

  endTextChatClick() {
    this.end.emit();
    this.bcAnalytics.eventTrack('EndTextChatButton');
  }

  transferButtonClick() {
    this.transfer.emit();
    this.bcAnalytics.eventTrack('TextChatTransferButton');
  }

  toggleButtonClick() {
    this.toggle.emit();
  }

  public hasSendGroupPanelItem(): boolean {
    return this.hasWrapUps;
  }
}

